/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface SMSLinkMethodOptions
 */
export interface SMSLinkMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof SMSLinkMethodOptions
     */
    method: FactorMethod;
    /**
     * URI to redirect to after resolving the challenge.
     * @type {string}
     * @memberof SMSLinkMethodOptions
     */
    redirect_target?: string;
}



/**
 * Check if a given object implements the SMSLinkMethodOptions interface.
 */
export function instanceOfSMSLinkMethodOptions(value: object): value is SMSLinkMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function SMSLinkMethodOptionsFromJSON(json: any): SMSLinkMethodOptions {
    return SMSLinkMethodOptionsFromJSONTyped(json, false);
}

export function SMSLinkMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSLinkMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
    };
}

export function SMSLinkMethodOptionsToJSON(json: any): SMSLinkMethodOptions {
    return SMSLinkMethodOptionsToJSONTyped(json, false);
}

export function SMSLinkMethodOptionsToJSONTyped(value?: SMSLinkMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'redirect_target': value['redirect_target'],
    };
}

